import React, { useState } from 'react';
import PropTypes, { any } from 'prop-types';

import CampDivisionSelectionCard from './CampDivisionSelectionCard';
import styles from './eventRegForm.scss';
import { regStepIds, registrationUserOptions } from '../../utils/eventConstants';
import { trackEvent } from '../Analytics/TrackedClick';

const CampDivisionSelection = ({ memberId, event, clubVerificationFee, multipleDivisionRegistrations, handleMultipleDivisionRegistrations, toStep }) => {
  const currencySymbol = event?.currency?.symbol || '$';
  const [errors, setErrors] = useState({});
  const hasSelectedDivision = Object.values(multipleDivisionRegistrations).some(division => division.quantity >= 1);
  const eventHasQuestions = event?.eventQuestions?.length > 0;

  const validatePlayerNames = () => {
    const newErrors = {};
    Object.entries(multipleDivisionRegistrations).forEach(([divisionId, registration]) => {
      const missingNames = registration.playerNames.reduce((acc, name, index) => {
        if (!name.trim()) {
          acc.push(index);
        }

        return acc;
      }, []);

      if (missingNames.length > 0) {
        newErrors[divisionId] = missingNames;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleContinue = () => {
    if (validatePlayerNames()) {
      trackMultipleRegistrations();
      if (eventHasQuestions) {
        toStep(regStepIds.CAMP_QUESTIONS);
      } else {
        toStep(regStepIds.CAMP_CONFIRM);
      }
    }
  };

  const trackMultipleRegistrations = () => {
    Object.entries(multipleDivisionRegistrations).forEach(([divisionId, { quantity }]) => {
      if (quantity >= 1) {
        trackEvent('Divisions Selected', {
          memberId,
          eventId: event?.id,
          divisionId,
          qty: quantity,
          registrationType: registrationUserOptions.MULTIPLE_PLAYERS,
        });
      }
    });
  };

  const divisionsFee = Object.values(multipleDivisionRegistrations).reduce((acc, { price }) => acc + price, 0);

  return (
      <div className="row">
          <div className="col-12">
              {event.eventDivisions.map(division => (
                  <CampDivisionSelectionCard
                      key={division.id}
                      division={division}
                      event={event}
                      clubVerificationFee={clubVerificationFee}
                      onSelectionChange={handleMultipleDivisionRegistrations}
                      currentRegistration={multipleDivisionRegistrations[division.id] || {}}
                      errorIndices={errors[division.id] || []}
                      currencySymbol={currencySymbol}
                  />
        ))}
          </div>
          <div className="col">
              <div className={styles.divisionsSelectSummaryWrapper}>
                  <div className="mt32 mb24">
                      <div className="mt4">
                        Division Fee <span className="float-right">{currencySymbol}{divisionsFee.toFixed(2)}</span>
                      </div>
                      <div className="mt4 text-black">
                        Subtotal <span className="float-right">{currencySymbol}{divisionsFee.toFixed(2)}</span>
                      </div>
                  </div>
                  <button
                      type="button"
                      className="btn btn-primary btn-xl btn-block text-uppercase mb24"
                      disabled={!hasSelectedDivision}
                      onClick={handleContinue}
                  >
                    Continue
                  </button>
              </div>
          </div>
      </div>
  );
};

CampDivisionSelection.propTypes = {
  memberId: PropTypes.number.isRequired,
  event: PropTypes.objectOf(any).isRequired,
  clubVerificationFee: PropTypes.number,
  toStep: PropTypes.func.isRequired,
  handleMultipleDivisionRegistrations: PropTypes.func.isRequired,
  multipleDivisionRegistrations: PropTypes.objectOf(any).isRequired,
};

CampDivisionSelection.defaultProps = {
  clubVerificationFee: 0,
};

export default CampDivisionSelection;
